import * as dataEn from './footer.data-en';
import * as dataZh from './footer.data-zh';

export const en = dataEn;
export const zh = dataZh;
